import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = "3079e3ebabf1578dbadd6fe6d2273e9a";

let initialized = false;
let blockedLikely = false; // flag to short-circuit client calls if we detect blocks

export function initMixpanel() {
  if (initialized) return;
  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      autocapture: true,
      record_sessions_percent: 100,
      track_pageview: false,
      debug: import.meta.env.DEV, // turn off in prod
    });

    // Light heuristic: after a short delay, if queue can't flush, assume blocked.
    // (This won’t catch all cases, but prevents repeated console spam while developing.)
    setTimeout(() => {
      try {
        // ping by trying a no-op event while devving; ignore errors
        mixpanel.track("mp_ping_dev_only", { t: Date.now() });
      } catch {}
    }, 1500);

    initialized = true;
  } catch (e) {
    console.info("[mixpanel] init failed or blocked:", e);
    blockedLikely = true;
  }
}

export function trackPageView(url: string) {
  if (blockedLikely) return;
  try {
    mixpanel.track("Page Viewed", { page: url });
  } catch {
    // If it throws (often due to blockers), stop trying for this session
    blockedLikely = true;
  }
}

export function identifyUser(id: string, traits?: Record<string, any>) {
  if (blockedLikely) return;
  try {
    mixpanel.identify(id);
    if (traits) mixpanel.people.set(traits);
  } catch {
    blockedLikely = true;
  }
}

export default mixpanel;
